exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".react__table .table{border-radius:.7em .7em 0 0;box-shadow:unset}.react__table .table .inner-table{border-radius:4px;overflow:hidden;margin-bottom:8px}.react__table.react__table--without_elevation{box-shadow:unset}.react__table.react__table--without_elevation .header .tr{border-radius:unset}.react__table .goto--input,.react__table .page--selection>div{background-color:#f5f7fa}", ""]);

// exports
